module.exports = __webpack_public_path__ + "static/media/df (4).af016f20.jpg";